<template>
  <div>

    <div class="d-flex justify-content-between">
      <h5 class="mt-1">Historial de Laboratorios</h5>
      <h6 class="text-right my-1 mx-1">Total: {{table.totalRows}}</h6>
    </div>

    <b-table 
      v-if="historialLabs.length"
      id = "tabla-labs" 
      responsive bordered
      :items="historialLabs" 
      :fields="fieldsLabs" 
      :per-page="table.perPage" 
      :current-page = "table.page" 
      small
    >

      <template #cell(fechaProgramada)="data">
        <small>
          {{ data.item.fechaProgramada || 'Sin fecha' }}
        </small>
      </template>

      <template #cell(examenes)="data">
        <small
          class="d-block text-left"
          v-for="(item, index)  in data.item.examenes" 
          :key="index"
        >
          {{ item.codigo}} - {{ item.descripcion }}
        </small>
      </template>  

      <template #cell(acciones)="data">
        <b-button 
          variant="info" 
          size="sm" 
          style="cursor: pointer; padding: 6px;"
          @click="onViewLaboratorio(data.item)"
        >
          <font-awesome-icon icon="magnifying-glass" style="color: white"/>
        </b-button>
      </template>

    </b-table>

    <div
      v-if="historialLabs.length && table.totalRows > table.perPage"
      class="d-flex justify-content-center"
    >
      <b-pagination 
        v-model="table.page"
        :total-rows="historialLabs.length"
        :per-page="table.perPage"
        aria-controls="tabla-labs"
      />
    </div>

    <b-skeleton-wrapper v-if="loadingData">
      <b-skeleton 
        v-for="i in 6"
        :key="i"
        width="100%" 
        height="35px"
      />
    </b-skeleton-wrapper>

    <EmptyResults
      size="sm"
      v-if="!historialLabs.length && !loadingData"
    />

    <ModalViewLab400/>

    <ViewDetailsAux/>

  </div>
</template>
  
<script>
import { BootstrapVue } from 'bootstrap-vue';
import { stringDateToGeneralDate, navigateToQuery } from '@/shared/helpers';
import { ModalViewLab400 } from '@/views/laboratorio/components';
import { labAs400Service, labAuxiliarService } from '@/views/laboratorio/services';
import { EmptyResults } from '@/shared/components';
import ViewDetailsAux from '@/views/laboratorio/components/LabAuxiliares/ViewDetailsAux.vue';

export default {
  props: {
    idPaciente : String
  },
  components: {
    ...BootstrapVue.components,
    ModalViewLab400,
    EmptyResults,
    ViewDetailsAux
  },

  created() {
    this.loadDataHistorial();
  },

  data() {
    return {

      historialLabs: [],
      loadingData : false,

      table: {
        perPage: 6,
        page: 1,
        totalRows: 0
      },

      fieldsLabs: [
        { key: "fechaProgramada", label: "Fecha" },
        { key: "examenes",        label: "Examenes" },
        // { key: "especialidad",    label: "Especialidad" },
        {
          key: "acciones",
          label: "Ver",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      
    }
  },

  methods : {

    async loadDataHistorial(){

      this.loadingData = true;

      // const responseLabAux = await labAuxiliarService.getAll(params);
      
      const labs400 = await this.getLabs400();
      const labsAux = await this.getLabsAux();


      const fusionLabs = [...labs400, ...labsAux];

      // Ordenar por fecha (los sin fecha al principio)
      fusionLabs.sort((a, b) => {
        const fechaA = a.fechaProgramada;
        const fechaB = b.fechaProgramada;

        if (!fechaA && !fechaB) return 0;
        if (!fechaA) return -1;
        if (!fechaB) return 1;

        // Convertir fechas a objetos Date si son strings
        const dateA = new Date(fechaA);
        const dateB = new Date(fechaB);

        return dateA - dateB;
      });

      this.table.totalRows = fusionLabs.length;

      this.historialLabs = fusionLabs;
      this.loadingData = false;
    },


    async getLabs400(){

      const params = {
        idPaciente : this.idPaciente
      };

      const responseSearch = await labAs400Service.getAll(params);

      if(!responseSearch) {
        return null;
      }


      const labsAs400Map = await Promise.all(responseSearch.data.map( async (lab) => {

        const fechaProgramada = lab.fechaProgramada 
          ? stringDateToGeneralDate(lab.fechaProgramada).date
          : 'Sin fecha';

        const examenesIdArray = lab.idslaboratorios 
          ? lab.idslaboratorios.split(',')
          : null;

        const dataExamenes = examenesIdArray  
          ? await Promise.all(examenesIdArray.map(id => labAs400Service.getExamensById(id)))
          : [];


        const dataResponse = {
          id             : lab.id,
          token          : lab.token,
          fechaProgramada: fechaProgramada,
          examenes       : dataExamenes,
          tipo           : 'as400'
        };

        return dataResponse;
      }));


      return labsAs400Map;

    },


    async getLabsAux(){

      const params = {
        idPaciente : this.idPaciente
      };

      const responseSearch = await labAuxiliarService.getAll(params);

      if(!responseSearch) {
        return null;
      }

      const dataLabs = responseSearch?.data;

      const dataLabsMapped = dataLabs.map( lab => {

        const examenes = lab.laboratorios ? JSON.parse(lab.laboratorios) : [];

        return {
          id              : lab.id,
          token           : lab.token,
          fechaProgramada : lab.fechaProgramada,
          examenes        : examenes,
          tipo            : 'auxiliar'
        }
      });

      return dataLabsMapped;
    },


    onViewLaboratorio(itemLab){

      const tipoLab = itemLab.tipo;
      const tokenLab = itemLab.token;

      if(tipoLab === 'as400'){
        navigateToQuery("view_laboratorio", tokenLab);
        return;
      }

      if(tipoLab === 'auxiliar'){
        navigateToQuery("view_aux", tokenLab);
        // return;
      }
    },

  },


};
</script>
  